import React from 'react'
import { useTranslation } from 'react-i18next'
import img1 from 'assets/img/concept-1.png'
import img2 from 'assets/img/concept-2.png'
import img3 from 'assets/img/concept-3.png'
import img4 from 'assets/img/concept-4.png'
import img5 from 'assets/img/concept-5.png'
import styles from './ConceptBlock.module.scss'

export const ConceptBlock = ({ number }) => {
  const { t } = useTranslation()
  const images = [img1, img2, img3, img4, img5]
  return (
    <div className={styles['block']}>
      <div className={styles['image']}>
        <img src={images[number-1]} alt={t('concept.block' + number + '.title')} />
      </div>
      <div className={styles['text']}>
        <div className={styles['content']}>
          <div className={styles['heading']}>
            <div className={styles['number']}>
              <div className={styles['badge']}>{number}</div>
            </div>
            <div className={styles['title']}>
              <h4>{t('concept.block' + number + '.title')}</h4>
            </div>
          </div>
          <p>{t('concept.block' + number + '.text')}</p>
        </div>
      </div>
    </div>
  )
}
